export const analyzePrice = (value) => {
  let data = [];
  value.map((product) => {
    let groupPrice = 0;
    let userPrice = 0;
    if (product.ListPrice.length === 0) {
      groupPrice = 0;
      userPrice = 0;
    } else if (product.ListPrice.length === 1) {
      if (product.ListPrice[0].IsG === true) {
        groupPrice = product.ListPrice[0].Price;
        userPrice = 0;
      } else {
        groupPrice = 0;
        userPrice = product.ListPrice[0].Price;
      }
    } else {
      if (product.ListPrice[0].IsG === true) {
        groupPrice = product.ListPrice[0].Price;
      } else {
        userPrice = product.ListPrice[0].Price;
      }
      if (product.ListPrice[1].IsG === true) {
        groupPrice = product.ListPrice[1].Price;
      } else {
        userPrice = product.ListPrice[1].Price;
      }
    }

    const dt = {
      ...product,
      GroupPrice: groupPrice.toLocaleString(),
      UserPrice: userPrice.toLocaleString(),
    };
    return data.push(dt);
  });
  return data;
};
